










import Vue from 'vue'
export default Vue.extend ({
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: null
        }
    },
    computed: {
        subtitleFont(): string {
            //  If on x-small screen return 'body-2'
            if (this.$vuetify.breakpoint.xsOnly) return 'subtitle'

            //  Else return  'body-1'
            return 'body-1'
        },
        titleFont(): string {
            if (this.$vuetify.breakpoint.xsOnly) return 'headline font-weight-medium'

            return 'display-1 font-weight-medium'
        }
    }
})
